const TYPE = 'REGISTRATION_DISCONNECTED';

const action = () => (dispatch) => dispatch({ type: TYPE });

export default { action, TYPE };
